module.exports = {"id":"205081","name":"Diego Oliveira","rating":"71","photo":"./data/images/photos/2/205081.png","club":{"name":"F.C. Tokyo","logo":"./data/images/clubs/F.C.Tokyo.png"},"positions":["BU"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DiegoOliveira0.json
// module id = 1091
// module chunks = 0